var TorsoView = require('backbone-torso/modules/View');
var PatientWalletInsurancesView = require('./PatientWalletInsurancesView');
var PatientStoredPaymentMethodsView = require('./PatientStoredPaymentMethodsView');
var patientWalletTemplate = require('./patientWalletTemplate.hbs');
var financialFeatureConfigModel = require('./../financial/financialFeatureConfigModel');
var insuranceFeatureConfigModel = require('./../appointment-insurance/insuranceFeatureConfigModel');

var NORMAL_FEATURE_CONFIG_LEVEL = insuranceFeatureConfigModel.CONFIG_LEVEL.NORMAL;

/**
 * View for displaying a patients wallet
 *
 * @class PatientWalletView
 * @constructor
 */
module.exports = TorsoView.extend({
  tagName: 'section',
  className: 'content-block',
  template: patientWalletTemplate,

  /**
   * @method initialize
   * @override
   * @param options {Object} configuration for this view
   * @param options.patientVecnaId {String} of the patient owning the payment methods
   */
  initialize:function(options) {
    options = options || {};
    this._patientVecnaId = options.patientVecnaId;
    this._walletInsurancesView = new PatientWalletInsurancesView({ patientVecnaId: this._patientVecnaId });
    this._patientStoredPaymentMethodsView = new PatientStoredPaymentMethodsView({ patientVecnaId: this._patientVecnaId });

    financialFeatureConfigModel.loadOnce();
    insuranceFeatureConfigModel.loadOnce();

    this.listenTo(financialFeatureConfigModel, 'load-complete', this.render);
    this.listenTo(insuranceFeatureConfigModel, 'load-complete', this.render);
  },

  /**
   * @method prepare
   */
  prepare: function() {
    var context = TorsoView.prototype.prepare.apply(this);
    var walletInsurancesEnabled = insuranceFeatureConfigModel.isWalletInsurancesEnabled(NORMAL_FEATURE_CONFIG_LEVEL);
    var storedPaymentsEnabled = financialFeatureConfigModel.isStoredPaymentMethodsEnabled(NORMAL_FEATURE_CONFIG_LEVEL);

    context.walletEnabled = walletInsurancesEnabled || storedPaymentsEnabled;
    return context;
  },

  /**
   * @method attachTrackedViews
   * @override
   */
  attachTrackedViews: function() {
    var walletInsurancesEnabled = insuranceFeatureConfigModel.isWalletInsurancesEnabled(NORMAL_FEATURE_CONFIG_LEVEL);
    if (walletInsurancesEnabled) {
      this.attachView('patient-wallet-insurances', this._walletInsurancesView);
    }
    var storedPaymentsEnabled = financialFeatureConfigModel.isStoredPaymentMethodsEnabled(NORMAL_FEATURE_CONFIG_LEVEL);
    if (storedPaymentsEnabled) {
      this.attachView('stored-payment-methods', this._patientStoredPaymentMethodsView);
    }
  }
});
